import React from 'react';
import PropTypes from 'prop-types';
import { DialogsProvider, ToastProvider } from '../../providers';
import { withContextProvider } from '../../hoc';
import Breadcrumbs from '../../componentsV2/Breadcrumbs/Breadcrumbs';
import OrganizationForm from './OrganizationForm';
import NotFound from '../NotFound/NotFound';

const OrganizationFormWrapper = ({ organization, isSuperadmin = false }) => {
  const breadcrumbLinks = [
    { href: '/admin', name: 'Admin' },
    { href: `/admin/organizations/${organization.id}`, name: 'Organization' },
  ];

  // Validate that the URL organization ID matches the organization prop ID
  const orgParam = window.location.pathname.split('/')[3];

  if (orgParam !== String(organization.id)) {
    return <NotFound />;
  }

  return (
    <DialogsProvider>
      <div className="mx-2.75">
        <header>
          <Breadcrumbs links={breadcrumbLinks} />
        </header>
        <OrganizationForm organization={organization} isSuperadmin={isSuperadmin} />
      </div>
    </DialogsProvider>
  );
};

OrganizationFormWrapper.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string,
    contact: PropTypes.string,
    contact_email: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  isSuperadmin: PropTypes.bool,
};

export default withContextProvider(ToastProvider)(OrganizationFormWrapper);
